import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import orAdminProductConstructorTableCeil from './components/admin/parts/global/or-admin-product-constructor-table-ceil.vue'
import orProductTableCeil from './components/global/or-product-table-ceil.vue'

document.addEventListener('mousedown', function (event) {
    if (event.detail > 1) {
      event.preventDefault();
    }
  }, false)

createApp(App)
.use(store)
.use(router)
.component('or-admin-product-constructor-table-ceil', orAdminProductConstructorTableCeil)
.component('or-product-table-ceil', orProductTableCeil)
.mount('#app')


